import { Group } from "@mui/icons-material";

export const GroupIcon = Group;
